import { render, staticRenderFns } from "./RawMaterialsCriticalStock.vue?vue&type=template&id=34893f6a&"
import script from "./RawMaterialsCriticalStock.vue?vue&type=script&lang=js&"
export * from "./RawMaterialsCriticalStock.vue?vue&type=script&lang=js&"
import style0 from "./RawMaterialsCriticalStock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports